import React from "react";
import HashTagTypeGeneralInfo from "../GeneralInfo";
import CardContainer from "../../../../components/Common/CardContainer";
import ButtonInput from "../../../../components/Common/ButtonInput";
import * as BootstrapVariants from "../../../../constants/Bootstrap/Variants";

const HashTagDetails = (props) => {
  const handleReturn = () => {
    props.history.push(`/hashTags`);
  };
  return (
    <CardContainer
      header={"HashTags Details"}
      backButton={
        <ButtonInput
          label="Back to List"
          type="button"
          variant={BootstrapVariants.OutlineSecondary}
          onClick={() => handleReturn()}
        />
      }
    >
      <HashTagTypeGeneralInfo hashTagId={props.match.params.hashTagId} />
    </CardContainer>
  );
};

export default HashTagDetails;
